import { CityDistrictBackfillRO } from '@routellers/types/dist/city-district/city-district.ro';
import { CityDistrictRO } from '@routellers/types/dist/city-district/city-district.ro';
import { BackfillCityDistrictsDto } from '@routellers/types/dist/city-district/backfill-city-districts.dto';
import { CreateCityDistrictDto } from '@routellers/types/dist/city-district/create-city-district.dto';
import { UpdateCityDistrictDto } from '@routellers/types/dist/city-district/update-city-district.dto';
import { UpsertCityDistrictLocaleDto } from '@routellers/types/dist/city-district/upsert-city-district-locale.dto';
import { QueryDto } from '@routellers/types/dist/shared/query.dto';
import { QueryRO } from '@routellers/types/dist/shared/query.ro';

import { ApiMethodDeclaration } from '..';

const query: ApiMethodDeclaration<QueryDto, QueryRO<CityDistrictRO>> = (params) => ({
    url: '/admin/city-districts',
    method: 'GET',
    params,
});

const getOne: ApiMethodDeclaration<number, CityDistrictRO> = (id) => ({
    url: `/admin/city-districts/${id}`,
    method: 'GET',
});

const create: ApiMethodDeclaration<{ data: CreateCityDistrictDto }, CityDistrictRO> = ({ data }) => ({
    url: '/admin/city-districts',
    method: 'POST',
    data,
});

const update: ApiMethodDeclaration<{ id: number; data: UpdateCityDistrictDto }, CityDistrictRO> = ({
    id,
    data,
}) => ({
    url: `/admin/city-districts/${id}`,
    method: 'PATCH',
    data,
});

const upsertLocale: ApiMethodDeclaration<
    { id: number; data: UpsertCityDistrictLocaleDto },
    CityDistrictRO
> = ({ id, data }) => ({
    url: `/admin/city-districts/${id}/locales`,
    method: 'PATCH',
    data,
});

const backfill: ApiMethodDeclaration<
    { data?: BackfillCityDistrictsDto },
    CityDistrictBackfillRO
> = ({ data }) => ({
    url: '/admin/city-districts/backfill',
    method: 'POST',
    data: data || {},
});

const remove: ApiMethodDeclaration<number, { ok: true }> = (id) => ({
    url: `/admin/city-districts/${id}`,
    method: 'DELETE',
});

export const cityDistrictsApiDeclaration = {
    query,
    getOne,
    create,
    update,
    upsertLocale,
    backfill,
    remove,
};
